module.exports = __webpack_public_path__ + "img/2015064.49eba093.svg";